var map = {
	"./NIM_Web_SDK_v5.8.0": "298f",
	"./NIM_Web_SDK_v5.8.0.js": "298f",
	"./NIM_Web_SDK_v6.1.0": "7c3b",
	"./NIM_Web_SDK_v6.1.0.js": "7c3b",
	"./NIM_Web_SDK_v7.5.0": "bf05",
	"./NIM_Web_SDK_v7.5.0.js": "bf05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6aa1";